import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Form, Icon, Input, Button, Upload, message, Row, Col } from 'antd';
import styled from 'styled-components';
import { FaWhatsapp } from 'react-icons/fa';
import { request } from '~/components/Instance';
import InputMask from '~/components/UI/InputMask';
import { getSubdomain } from '~/helpers/getSubdomain';
import { AccountStorage } from '~/storages/account';
import { useAppContext } from '~/AppContext';
import CollapsibleSection from '../components/CollapsibleSection';

var FormCard = styled.div`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 20px 24px;
  .ant-form-item { margin-bottom: 16px; }
  .ant-form-item:last-child { margin-bottom: 0; }
  .ant-form-item-label { line-height: 1.5; padding-bottom: 4px; }
  .ant-form-item-label label { font-size: 13px; font-weight: 500; color: #595959; }
  .ant-input { border-radius: 6px; height: 40px; font-size: 14px; }
  .ant-btn { height: 40px; font-size: 14px; padding: 0 24px; }
`;

var PendingFieldWrapper = styled.div`
  .ant-input {
    border-color: #ffccc7;
    background: #fff2f0;
  }
`;

var LogoArea = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px 24px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px 8px 0 0;
  border-bottom: none;
`;

var LogoPreview = styled.div`
  width: 88px;
  height: 88px;
  border-radius: 12px;
  border: 2px dashed #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  background: #fafafa;
  transition: border-color 0.2s;
  &:hover { border-color: #1890ff; }
  img { width: 100%; height: 100%; object-fit: contain; }
`;

var LogoInfo = styled.div`
  flex: 1;
`;

var LogoInfoTitle = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 4px;
`;

var LogoInfoDesc = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  line-height: 1.5;
`;

var FooterBar = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 1100px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 24px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  z-index: 1020;

  .ant-btn {
    height: 44px;
    font-size: 15px;
    padding: 0 32px;
    border-radius: 8px;
  }
`;

var phoneMaskProps = {
  mask: "(99) 9999tt999?",
  formatChars: { "9": "[0-9]", "t": "[0-9\-]", "?": "[0-9 ]" },
  maskChar: null,
  placeholder: "(00) 00000-0000"
};

var whatsappDepts = [
  { key: 'legalization_phone', label: 'Legalização', icon: 'audit' },
  { key: 'administrative_phone', label: 'Administrativo', icon: 'solution' },
  { key: 'accounting_phone', label: 'Contábil', icon: 'calculator' },
  { key: 'fiscal_phone', label: 'Fiscal', icon: 'file-protect' },
  { key: 'personal_phone', label: 'Pessoal', icon: 'team' },
  { key: 'audit_phone', label: 'Sucesso do Cliente', icon: 'customer-service' },
];

var renderPendingField = function(isEmpty, formItem) {
  if (isEmpty) {
    return (
      <PendingFieldWrapper>
        {formItem}
      </PendingFieldWrapper>
    );
  }
  return formItem;
};

var SettingsCompanyForm = function(props) {
  var form = props.form;
  var company = props.company;
  var section = props.section || 'dados';
  var updateCompany = props.updateCompany;
  var loadingState = useState(false);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  var imageUrlState = useState(company.logoUrl);
  var imageUrl = imageUrlState[0];
  var setImageUrl = imageUrlState[1];
  var savingState = useState(false);
  var isSaving = savingState[0];
  var setIsSaving = savingState[1];
  var appContext = useAppContext();
  var setOnboardingTaskAsDone = appContext.setOnboardingTaskAsDone;

  var getBase64 = function(img, callback) {
    var reader = new FileReader();
    reader.addEventListener('load', function() { callback(reader.result); });
    reader.readAsDataURL(img);
  };

  var handleSubmit = function(e) {
    e.preventDefault();
    form.validateFieldsAndScroll(function(err, values) {
      if (!err) {
        setIsSaving(true);
        request('patch', '/company', values).then(function() {
          updateCompany({
            name: values.name, legal_name: values.legal_name,
            accountant: values.accountant, crc: values.crc,
            national_register: values.national_register,
            website: values.website, email: values.email, phone: values.phone,
            address: values.address, zipcode: values.zipcode,
            city: values.city, state: values.state,
            legalization_phone: values.legalization_phone,
            administrative_phone: values.administrative_phone,
            accounting_phone: values.accounting_phone,
            fiscal_phone: values.fiscal_phone,
            personal_phone: values.personal_phone,
            audit_phone: values.audit_phone,
          });
          setOnboardingTaskAsDone('g7h8i9');
          message.success('Dados salvos com sucesso!');
        }).finally(function() { setIsSaving(false); });
      }
    });
  };

  var dataFiles = {
    action: process.env.REACT_APP_API + '/auth/company/logo',
    multiple: false,
    showUploadList: false,
    headers: {
      Authorization: 'Bearer ' + AccountStorage.get().token,
      'X-Tenant': getSubdomain()
    },
    onChange: function(info) {
      if (info.file.status === 'uploading') { setLoading(true); setImageUrl(null); return; }
      if (info.file.status === 'done') {
        getBase64(info.file.originFileObj, function(url) {
          setImageUrl(url); setLoading(false);
          setOnboardingTaskAsDone('j0k1l2');
          updateCompany({ logoUrl: url });
          message.success('Logo atualizada com sucesso!');
        });
      }
    },
    beforeUpload: function(file) {
      var isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) message.error('Apenas arquivos JPG/PNG são permitidos!');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) message.error('A imagem deve ter menos de 2MB!');
      return isJpgOrPng && isLt2M;
    }
  };

  if (section === 'dados') {
    return (
      <Form layout="vertical" onSubmit={handleSubmit}>
        <LogoArea>
          <Upload {...dataFiles}>
            <LogoPreview>
              {loading ? (
                <Icon type="loading" style={{ fontSize: 24, color: '#1890ff' }} />
              ) : imageUrl ? (
                <img src={imageUrl} alt="Logo" />
              ) : (
                <div style={{ textAlign: 'center', color: '#bfbfbf' }}>
                  <Icon type="camera" style={{ fontSize: 24, display: 'block', marginBottom: 4 }} />
                  <span style={{ fontSize: 11 }}>Upload</span>
                </div>
              )}
            </LogoPreview>
          </Upload>
          <LogoInfo>
            <LogoInfoTitle>Logo da empresa</LogoInfoTitle>
            <LogoInfoDesc>Formato JPG ou PNG, tamanho máximo 2MB.</LogoInfoDesc>
          </LogoInfo>
        </LogoArea>

        <FormCard style={{ borderRadius: '0 0 8px 8px' }}>
          <Row gutter={16}>
            <Col span={12}>
              {renderPendingField(!company.name,
                <Form.Item label="Nome Fantasia">
                  {form.getFieldDecorator('name', {
                    initialValue: company.name,
                    rules: [{ required: true, message: 'Informe o nome fantasia' }],
                  })(<Input placeholder="Nome fantasia da empresa" />)}
                </Form.Item>
              )}
            </Col>
            <Col span={12}>
              {renderPendingField(!company.legal_name,
                <Form.Item label="Razão Social">
                  {form.getFieldDecorator('legal_name', {
                    initialValue: company.legal_name,
                    rules: [{ required: true, message: 'Informe a razão social' }],
                  })(<Input placeholder="Razão social completa" />)}
                </Form.Item>
              )}
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              {renderPendingField(!company.national_register,
                <Form.Item label="CNPJ">
                  {form.getFieldDecorator('national_register', {
                    initialValue: company.national_register,
                    rules: [{ required: true, message: 'Informe o CNPJ' }],
                  })(<InputMask mask="99.999.999/9999-99" formatChars={{ "9": "[0-9]" }} maskChar={null} placeholder="00.000.000/0000-00" />)}
                </Form.Item>
              )}
            </Col>
            <Col span={12}>
              {renderPendingField(!company.accountant,
                <Form.Item label="Contador Responsável">
                  {form.getFieldDecorator('accountant', {
                    initialValue: company.accountant,
                    rules: [{ required: true, message: 'Informe o contador responsável' }],
                  })(<Input placeholder="Nome do contador" />)}
                </Form.Item>
              )}
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              {renderPendingField(!company.crc,
                <Form.Item label="CRC">
                  {form.getFieldDecorator('crc', {
                    initialValue: company.crc,
                    rules: [{ required: true, message: 'Informe o registro no CRC' }],
                  })(<Input placeholder="Registro no CRC" />)}
                </Form.Item>
              )}
            </Col>
          </Row>
        </FormCard>

        <CollapsibleSection
          title="Endereço"
          description="Localização do escritório"
          icon={<Icon type="environment" />}
          bg="#f9f0ff"
          color="#722ed1"
          defaultOpen={false}
        >
          <FormCard style={{ borderRadius: '0 0 8px 8px' }}>
            <Row gutter={16}>
              <Col span={16}>
                <Form.Item label="Endereço">
                  {form.getFieldDecorator('address', {
                    initialValue: company.address,
                  })(<Input placeholder="Rua, número, complemento" />)}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="CEP">
                  {form.getFieldDecorator('zipcode', {
                    initialValue: company.zipcode,
                  })(<InputMask mask="99999-999" formatChars={{ "9": "[0-9]" }} maskChar={null} placeholder="00000-000" />)}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={16}>
                <Form.Item label="Município">
                  {form.getFieldDecorator('city', {
                    initialValue: company.city,
                  })(<Input placeholder="Nome do município" />)}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="Estado">
                  {form.getFieldDecorator('state', {
                    initialValue: company.state,
                  })(<Input placeholder="UF" />)}
                </Form.Item>
              </Col>
            </Row>
          </FormCard>
        </CollapsibleSection>

        <CollapsibleSection
          title="Contato"
          description="Email, telefone e site do escritório"
          icon={<Icon type="phone" />}
          bg="#f6ffed"
          color="#52c41a"
          defaultOpen={false}
        >
          <FormCard style={{ borderRadius: '0 0 8px 8px' }}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Email">
                  {form.getFieldDecorator('email', {
                    initialValue: company.email,
                  })(<Input placeholder="email@empresa.com.br" />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Telefone">
                  {form.getFieldDecorator('phone', {
                    initialValue: company.phone,
                  })(<InputMask mask="(99) 9999tt999?" formatChars={{ "9": "[0-9]", "t": "[0-9\-]", "?": "[0-9 ]" }} maskChar={null} placeholder="(00) 00000-0000" />)}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item label="Site">
                  {form.getFieldDecorator('website', {
                    initialValue: company.website,
                  })(<Input placeholder="https://www.empresa.com.br" />)}
                </Form.Item>
              </Col>
            </Row>
          </FormCard>
        </CollapsibleSection>

        <FooterBar>
          <Button type="primary" htmlType="submit" loading={isSaving} icon="save">
            Salvar
          </Button>
        </FooterBar>
      </Form>
    );
  }

  if (section === 'whatsapp') {
    return (
      <Form layout="vertical" onSubmit={handleSubmit}>
        <FormCard>
          <Row gutter={16}>
            {whatsappDepts.map(function(dept) {
              return (
                <Col span={12} key={dept.key}>
                  <Form.Item label={<span><Icon type={dept.icon} style={{ marginRight: 6, color: '#52c41a' }} />{dept.label}</span>}>
                    {form.getFieldDecorator(dept.key, {
                      initialValue: company[dept.key],
                    })(<InputMask {...phoneMaskProps} />)}
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
          <FooterBar>
            <Button type="primary" htmlType="submit" loading={isSaving} icon="save">
              Salvar
            </Button>
          </FooterBar>
        </FormCard>
      </Form>
    );
  }

  return null;
};

var mapStateToProps = function(state) {
  return { company: state.user.tenant };
};

var mapDispatchToProps = function(dispatch) {
  return {
    updateCompany: function(data) { dispatch({ type: 'UPDATE_COMPANY', payload: data }); }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(SettingsCompanyForm));
